<template lang="html">
  <div class="row">
    <div class="col-lg-6 lbv-admin">
      <b-card header="Remove device from user">
        <div class="form-row">
          <b-btn
            v-model="removeDevice"
            v-b-modal.modal1
            class="removeDevice"
            variant="primary"
            @click="showModal = true"
          >
            Remove Device From User
          </b-btn>
        </div>

        <b-modal
          id="modal1"
          title="Remove device"
          ok-variant="danger"
          ok-title="Remove device"
          cancel-variant="primary"
          cancel-title="Cancel"
          @ok="RemoveModalDevice"
        >
          <p><strong>Removing a device cannot be undone.</strong></p>
          <p>
            By removing a device the account will no longer be available for the user or admin/ops.</br>
            Are you sure you want to remove device from this user?
          </p>
        </b-modal>
      </b-card>
    </div>
    <div class="col-lg-6 lbv-admin">
      <b-card header="Analysing Mode">
        <div class="form-row">
          <div class="btnCtrl">
            <label class="switch switch-text switch-pill switch-secondary">
              <input
                ref="switchBtn"
                v-b-modal.modalAnalysingMode
                type="checkbox"
                class="switch-input"
                variant="primary"
                @click="showModal = true"
              >
              <span
                class="switch-label"
                data-on="On"
                data-off="Off"
              />
              <span class="switch-handle" />
            </label>
          </div>

          <b-modal
            id="modalAnalysingMode"
            ok-variant="primary"
            ok-title="Yes"
            cancel-title="Cancel"
            @ok="setAnalysingMode"
            @cancel="cancelAnalysingMode"
          >
            <p class="bolder">
              Are you sure you want to set/unset this device to analysing mode?
            </p>
            <p class="bold">
              This will trigger new comms to be sent to the customer.
            </p>
            <p>Remember to select the reason for switching device to analysing mode from the options provided.</p>
          </b-modal>

          <div class="col-md-4 left">
            <legend>Install Environment:</legend>
            <b-form-checkbox
              v-model="headerTank"
              :plain="true"
              value="1"
              unchecked-value="0"
              :value="1"
              @input="installEnvironment($event)"
            >
              Header Tank
            </b-form-checkbox>
            <b-form-checkbox
              v-model="hotPipeEnvironment"
              :plain="true"
              value="1"
              unchecked-value="0"
              :value="1"
              @input="installEnvironment($event)"
            >
              Hot Pipe Environment
            </b-form-checkbox>
          </div>

          <div class="col-md-4 left">
            <b-form-checkbox
              v-model="underfloorHeating"
              :plain="true"
              value="1"
              unchecked-value="0"
              :value="1"
              @input="installEnvironment($event)"
            >
              Underfloor Heating
            </b-form-checkbox>
            <b-form-checkbox
              v-model="coldVoid"
              :plain="true"
              value="1"
              unchecked-value="0"
              :value="1"
              @input="installEnvironment($event)"
            >
              Cold Void
            </b-form-checkbox>
            <b-form-checkbox
              v-model="unknown"
              :plain="true"
              value="1"
              unchecked-value="0"
              :value="1"
              @input="installEnvironment($event)"
            >
              Unknown
            </b-form-checkbox>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import { APIEvent } from '../../events/apiEvent'
import { StatusBarEvent } from '../../events/statusBarEvent'
import { EventBus } from '../../event-bus'
import * as Routes from '../../constants/routes'
import { TabNavEvent } from '../../events/tabNavEvent'
import api from '../../api'
import { JSONToCSVConvertor, createReportsLabel } from '../../utils'
export default {
  name: 'AdminView',
  props: ['lb_id', 'highUsageOnly', 'headerTankCheckbox', 'coldVoidCheckbox', 'underfloorHeatingCheckbox', 'hotPipeEnvironmentCheckbox', 'unknownCheckbox'],
  data () {
    return {
      removeDevice: false,
      highUsageOnlyValue: this.highUsageOnlyInit,
      headerTank: this.headerTankInit,
      hotPipeEnvironment: this.hotPipeEnvironmentInit,
      underfloorHeating: this.underfloorHeatingInit,
      coldVoid: this.coldVoidInit,
      unknown: this.unknownInit
    }
  },
  mounted () {
    EventBus.$on(TabNavEvent.ADMIN, () => { this.init() })
    this.getDeviceId()
  },
  destroyed () {
    EventBus.$off(TabNavEvent.ADMIN)
  },
  methods: {
    init: function () {
      this.removeDevice = true
    },
    removeDeviceFromUser (event) {
      if (this.removeDevice) {
        this.RemoveModalDevice()
      }
    },
    RemoveModalDevice (event) {
      // console.log('RemoveModalDevice')
      let deviceID = {'leakbot_id': this.$route.params.deviceID}
      this.$store.dispatch(APIEvent.REMOVE_DEVICE_FROM_USER, deviceID)
        .then((response) => {
          if (response.data.ack) {
            EventBus.$emit(StatusBarEvent.SUCCESS, 'You have successfully removed the device from this user. This device ID may now be assigned to another user if required.')
            this.$router.push(Routes.DEVICE_LIST)
          }
        })
        .catch(this.handleError)
    },
    setAnalysingMode (event) {
      let options = {}
      let message = ''
      if (this.$refs.switchBtn.checked === true) {
        this.highUsageOnlyInit = true
        options.set = '1'
        message = 'You have successfully set the analysing mode.'
      } else {
        options.set = '0'
        this.$refs.switchBtn.checked = false
        this.highUsageOnlyInit = false
        message = 'You have successfully unset the analysing mode.'
      }
      options.parameter_code = 'High Usage Only'
      options.LbDevice_ID = this.lb_id
      this.$store.dispatch(APIEvent.INSTALL_ENVIRONMENT, options)
        .then((response) => {
          if (response.data.ack) {
            EventBus.$emit(StatusBarEvent.SUCCESS, message)
          }
        })
        .catch(this.handleError)
    },
    cancelAnalysingMode (event) {
      if (this.highUsageOnlyInit) {
        this.$refs.switchBtn.checked = true
      } else {
        this.$refs.switchBtn.checked = false
      }
    },
    handleError: function (error) {
      EventBus.$emit(StatusBarEvent.ERROR, error.message)
    },
    downloadReports: function (event) {
      var DataApi = {'start_date': '2016-10-10 00:00:00', 'end_date': '2016-10-10 06:00:00'}
      var headings = {
        'v4': 'Surname',
        'v13': 'LeakBot ID',
        'v21': 'Serial Number',
        'v16': 'Post Code',
        'v17': 'Sigfox ID',
        'v1': 'Customer Install Date',
        'v8': 'In logging',
        'v14': 'Logging End Date',
        'v15': 'Logging Start Date',
        'v2': 'Customer Status',
        'v3': 'Customer Status Change Date'
      }

      api.request('post', 'LbReport/Report/CustomerOverview', DataApi)
        .then(response => {
          var JsonData = JSON.stringify(response.data.report.device)
          if (JsonData !== '') {
            var title = createReportsLabel('Export data')
            JSONToCSVConvertor(JsonData, title, true, headings)
          }
        })
        .catch(this.handleError)
    },
    installEnvironment ($event) {
      let options = {}
      options.LbDevice_ID = this.lb_id
      let apiCall = false
      if ($event === 1) {
        options.set = '1'
      } else { options.set = '0' }

      if (this.headerTank !== this.headerTankInit) {
        options.parameter_code = 'Header Tank'
        this.headerTankInit = $event
        apiCall = true
      } else if (this.hotPipeEnvironment !== this.hotPipeEnvironmentInit) {
        options.parameter_code = 'Hot Pipe Environment'
        this.hotPipeEnvironmentInit = $event
        apiCall = true
      } else if (this.underfloorHeating !== this.underfloorHeatingInit) {
        options.parameter_code = 'Underfloor Heating'
        this.underfloorHeatingInit = $event
        apiCall = true
      } else if (this.coldVoid !== this.coldVoidInit) {
        options.parameter_code = 'Cold Void'
        this.coldVoidInit = $event
        apiCall = true
      } else if (this.unknown !== this.unknownInit) {
        options.parameter_code = 'Unknown'
        this.unknownInit = $event
        apiCall = true
      }
      if (apiCall === true) {
        this.$store.dispatch(APIEvent.INSTALL_ENVIRONMENT, options)
          .then((response) => {
          })
          .catch(this.handleError)
      }
    },
    getDeviceId: function () {
      let id = this.$route.params.deviceID
      this.$store.dispatch(APIEvent.FETCH_DEVICE, id)
        .then((res) => {
          if (res.data.install_environment.length > 0) {
            let installEnvironmentArray = res.data.install_environment

            for (var i = 0; i < installEnvironmentArray.length; i++) {
              switch (installEnvironmentArray[i]) {
                case 'High Usage Only':
                  this.highUsageOnly = 'High Usage Only'
                  this.highUsageOnlyInit = true
                  // this.highUsageOnlyValue = true
                  this.$refs.switchBtn.checked = true
                  break
                case 'Cold Void':
                  this.coldVoidInit = '1'
                  this.coldVoid = '1'
                  break
                case 'Header Tank':
                  this.headerTankInit = '1'
                  this.headerTankInitialisation = true
                  this.headerTank = '1'
                  break
                case 'Underfloor Heating':
                  this.underfloorHeatingInit = '1'
                  this.underfloorHeating = '1'
                  break
                case 'Hot Pipe Environment':
                  this.hotPipeEnvironmentInit = '1'
                  this.hotPipeEnvironment = '1'
                  break
                case 'Unknown':
                  this.unknownInit = '1'
                  this.unknown = '1'
                  break
              }
              if (typeof this.hotPipeEnvironmentInit === 'undefined') {
                this.hotPipeEnvironment = '0'
                this.hotPipeEnvironmentInit = '0'
              } else if (typeof this.coldVoidInit === 'undefined') {
                this.coldVoidInit = '0'
                this.coldVoid = '0'
              } else if (typeof this.unknownInit === 'undefined') {
                this.unknownInit = '0'
                this.unknown = '0'
              } else if (typeof this.underfloorHeatingInit === 'undefined') {
                this.underfloorHeatingInit = '0'
                this.underfloorHeating = '0'
              } else if (typeof this.headerTankInit === 'undefined') {
                this.headerTankInit = '0'
                this.headerTank = '0'
              }
            }
          }
        })
    }
  }
}
</script>

<style scoped lang="css">
  .removeDevice{
    background-color: #FB5B6E !important;
    border-color: #FB5B6E !important;
  }

  .exportData{
    margin-left: 20px !important;
  }

  .form-check-inline {
    display: block;
    margin-left: 0;
  }

  legend {
    font-size: 1rem;
    font-weight: bold;
  }

  .btnCtrl {
    width: 18%;
    margin-right: 5%;
    border-right: 1px solid #BCBCBC;
  }

  .switch.switch-text {
    width: 78px;
    height: 44px;
  }

  .switch.switch-text .switch-handle {
    width: 40px;
    height: 40px;
  }

  .switch.switch-text .switch-input:checked ~ .switch-handle {
    left: 37px;
  }

  .switch.switch-text .switch-label {
    background-color: #f2f2f2;
  }

  .bold {
    font-weight: bold;
  }

  .bolder {
    font-weight: bolder;
    font-size: 16px;
  }
</style>
